import { getElement, getElements } from '../utils/functional'

export default class pushCart {
  constructor (el) {
    this.el = el
    this.els = getElements('.js-FadeInMenu')

    this._drawerIsOpen = false
    this.timeouts = []

    this.activeClass = 'fde-Fadein-active'

    const observer = new MutationObserver(mutationsList => {
      mutationsList.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          this.drawerIsOpen = mutation.target.classList.contains(
            'drw-Drawer-active'
          )
        }
      })
    })
    observer.observe(this.el, {
      attributes: true,
      childList: false,
      subtree: false
    })
  }

  get drawerIsOpen () {
    return this._drawerIsOpen
  }

  set drawerIsOpen (val) {
    this._drawerIsOpen = val

    if (this._drawerIsOpen === false) {
      this.timeouts.forEach(timeout => clearTimeout(timeout))
      this.timeouts = []
    }

    this.els.forEach((el, index) => {
      const timeout = this._drawerIsOpen ? index * 80 : 0

      this.timeouts.push(
        setTimeout(() => {
          const classListAction = this._drawerIsOpen ? 'add' : 'remove'
          el.classList[classListAction](this.activeClass)
        }, timeout)
      )
    })
  }
}
